import { AccountStateModel } from 'models/AccountState';
import { Company } from "models/Company"

//type Visibility = "all" | "completed" | "active";

export type AccountAction =
  | { type: "set_current_company"; company: Company | any }
  | { type: "remove_current_company"; id: number }
  | { type: "add_company"; payload: Company }
  | { type: "update_company"; payload: Company }
  | { type: "add_companies"; payload: Company[] }
  | { type: "remove_companies"; }
  | { type: "remove_company"; payload:Company }
  | { type: "loading_companies"; loading:boolean };

export const accountReducer = (stateAccount: AccountStateModel, action: AccountAction) : AccountStateModel => {
    switch (action.type)
    {
      case 'set_current_company':
        return {...stateAccount, currentCompany: action.company};
      case 'add_company' :
        let _company = action.payload;
        if(stateAccount.companies.filter(x => x.id === _company.id).length === 0) {
          let _companies = [...stateAccount.companies, _company]
          return {...stateAccount, companies: _companies};
        }
        return stateAccount;
      case 'add_companies' :
        return {...stateAccount, companies: action.payload}
      case 'update_company' :
        let _index = stateAccount.companies.findIndex(x => x.id === action.payload.id);
        stateAccount.companies[_index] = action.payload;
        return stateAccount;
      case 'remove_companies' :
        stateAccount.companies = [];
        return stateAccount;
      case 'remove_company' : 
      let companies = stateAccount.companies.filter(x => x.id !== action.payload.id);
        return {...stateAccount, companies: companies};
      case 'loading_companies' :
        stateAccount.loadingCompanies = action.loading
        return stateAccount;
      default:
        return stateAccount;
    }
};